import { DatePipe, NgTemplateOutlet } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, Input, input } from '@angular/core'

import { ImageOptions, LinkTarget, LinkTargetOptional, Media } from 'app/core/cms/generated/api-types'
import { IconName } from 'app/core/icons.const'

import { LayoutContainer } from '../../dynamic-components/sections/layout-container'
import { CmsLinkDirective } from '../cms-link/cms-link.directive'
import { PictureComponent } from '../picture/picture.component'
import { RippleDirective } from '../ripple/ripple.directive'
import { IconComponent } from '../svg/icon.component'
import { TranslatePipe } from '../translate.pipe'

@Component({
  selector: 'pai-anchor-card',
  templateUrl: './anchor-card.component.html',
  styleUrls: ['./anchor-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    DatePipe,
    TranslatePipe,
    RippleDirective,
    PictureComponent,
    IconComponent,
    CmsLinkDirective,
  ],
  host: {
    '[attr.alignment]': 'alignment',
  },
})
export class AnchorCardComponent {
  @Input() title: string | null
  @Input() image: Media | null
  readonly imageOptions = input<ImageOptions | null>(null)
  @Input() alignment: 'left' | 'center' = 'left'
  @Input() text?: string | null
  @Input() date?: Date | null
  @Input() target?: LinkTarget | LinkTargetOptional | string | null
  @Input() preserveQueryParams: boolean = false
  @Input() ctaKey?: string | null
  @Input() ctaIcon?: IconName | null

  protected get isInternalLink(): boolean {
    return typeof this.target === 'object' && this.target !== null
  }

  protected get internalLink(): LinkTarget | LinkTargetOptional {
    if (typeof this.target !== 'object' || this.target === null) {
      throw new Error('target is not internal link')
    }
    return this.target
  }

  protected get isExternalLink(): boolean {
    return typeof this.target === 'string'
  }

  protected get externalLink(): string {
    if (!(typeof this.target === 'string')) {
      throw new Error('target is not an external Link')
    }
    return this.target
  }

  protected readonly parentLayout = inject(LayoutContainer).containerInfo
}
